<template>
  <ul class="nav navbar-nav">
    <li class="dropdown language-switch">
      <a
        href="#"
        class="dropdown-toggle"
        data-toggle="dropdown"
        id="language-switcher-icon"
        :title="$t('common.changeLanguage')"
        style="text-align: center"
      >
        <img
          :src="currentLanguage.flag"
          :alt="currentLanguage.code"
          width="18"
          height="18"
          style="border-radius: 50%; object-fit: cover; vertical-align: middle; margin-top: 5px;"
        >
      </a>

      <ul class="dropdown-menu">
        <li
          v-for="lang in languages"
          :key="lang.code"
          :class="{ active: lang.code === currentLanguage.code }"
        >
          <a href="#" @click.prevent="selectLanguage(lang.code)">
            <img
              :src="lang.flag"
              :alt="lang.code"
              width="18"
              height="18"
              style="border-radius: 50%; object-fit: cover;" class="rtl-mr-8"
            >
            {{ lang.label }}
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      languages: [
        { code: 'en', label: 'English', flag: require('../../assets/flags/flag_united_kingdom.svg') },
        { code: 'ar', label: 'العربية', flag: require('../../assets/flags/flag_iraq.svg') },
        { code: 'ku', label: 'کوردی سۆرانی', flag: require('../../assets/flags/flag_kurdistan.svg') },
        { code: 'tr', label: 'Türkçe', flag: require('../../assets/flags/flag_turkey.svg') }
      ]
    }
  },

  computed: {
    currentLanguage() {
      const saved = localStorage.getItem('app_locale') || 'en'
      return this.languages.find((lang) => lang.code === saved) || this.languages[0]
    }
  },

  methods: {
    selectLanguage(code) {
      if (code === this.currentLanguage.code) {
        return
      }

      let token = localStorage.getItem('access_token')
      axios
        .patch('update-language', { language: code }, { headers: { Authorization: 'Bearer ' + token } })
        .then(() => {
          this.persistAndReload(code)
        })
        .catch(() => {
          // Persist locally even if the backend sync fails, so the user isn't
          // blocked from switching the UI language by a transient network error.
          this.persistAndReload(code)
        })
    },

    persistAndReload(code) {
      localStorage.setItem('app_locale', code)

      const userData = JSON.parse(localStorage.getItem('user_data') || '{}')
      userData.language = code
      localStorage.setItem('user_data', JSON.stringify(userData))

      window.location.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/languageSwitcher.vue